interface TelegramWebApp {
  colorScheme?: 'light' | 'dark';
  initData?: string;
  ready(): void;
  expand(): void;
  openLink(url: string): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp: TelegramWebApp };
  }
}

export function initializeTelegram(): void {
  const webApp = window.Telegram?.WebApp;
  if (!webApp) return;
  webApp.ready();
  webApp.expand();
  document.documentElement.dataset.telegram = 'true';
}

export function openAuth(url: string): void {
  const webApp = window.Telegram?.WebApp;
  if (webApp) webApp.openLink(url);
  else window.location.assign(url);
}
